var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { Badge, Box, Hidden, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Typography, } from "@material-ui/core";
import { Add, Delete } from "@material-ui/icons";
import { Skeleton } from "@material-ui/lab";
import { usePagination } from "frontend/src/lib/pagination";
import { AudioControlButton } from "frontend/src/ui/audio-control-button";
import { usePlayerTrackId } from "frontend/src/domain/player-track-queue";
import { useIsAudioLoading, useIsAudioPlaying, } from "frontend/src/domain/audio";
import { resume, pause } from "frontend/src/features/control-audio";
import { playSearchResultAttempted } from "frontend/src/features/play-search-result";
import { TrackTableRow } from "frontend/src/ui/track-table-row";
import { useTracksSearchResult } from "../selectors";
export var SearchCatalogResult = function (_a) {
    var params = _a.params, addedTrackCounter = _a.addedTrackCounter, onTrackAdd = _a.onTrackAdd, onTrackRemove = _a.onTrackRemove;
    var _b = usePagination({ page: 0, rowsPerPage: 25, pageResetDeps: [params] }), page = _b.page, skip = _b.skip, rowsPerPage = _b.rowsPerPage, onChangeRowsPerPage = _b.onChangeRowsPerPage, onChangePage = _b.onChangePage;
    var _c = useTracksSearchResult({
        params: __assign(__assign({}, params), { limit: rowsPerPage, offset: skip }),
    }), data = _c.data, isLoading = _c.isLoading, isFetching = _c.isFetching;
    var play = function (_a) {
        var selected = _a.selected, id = _a.id;
        if (data) {
            if (selected) {
                resume();
            }
            else {
                playSearchResultAttempted({
                    tracks: data.tracks,
                    startAtTrackIndex: data.tracks.findIndex(function (track) { return track.id === id; }),
                });
            }
        }
    };
    var selectedTrackId = usePlayerTrackId();
    var isAudioPlaying = useIsAudioPlaying();
    var isAudioLoading = useIsAudioLoading();
    if (!isLoading && !isFetching && (data === null || data === void 0 ? void 0 : data.tracks.length) === 0) {
        return React.createElement(Typography, null, "\u041D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E \u043D\u0438 \u043E\u0434\u043D\u043E\u0433\u043E \u0442\u0440\u0435\u043A\u0430.");
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(TableContainer, { component: Paper },
            React.createElement(Table, null,
                React.createElement(Hidden, { xsDown: true },
                    React.createElement(TableHead, null,
                        React.createElement(TableRow, null,
                            React.createElement(TableCell, null),
                            React.createElement(TableCell, null, "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435"),
                            React.createElement(TableCell, null, "\u0418\u0441\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C"),
                            React.createElement(TableCell, null, "\u0416\u0430\u043D\u0440\u044B"),
                            React.createElement(TableCell, null, "\u0414\u043B\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0441\u0442\u044C"),
                            React.createElement(TableCell, null),
                            React.createElement(TableCell, null)))),
                React.createElement(TableBody, null,
                    data &&
                        data.tracks.map(function (track) {
                            var addCounter = addedTrackCounter[track.id];
                            var isAdded = typeof addCounter === "number";
                            var selected = selectedTrackId === track.id;
                            var playing = isAudioPlaying && selected;
                            var loading = isAudioLoading && selected;
                            var onPlay = function () { return play({ id: track.id, selected: selected }); };
                            return (React.createElement(TrackTableRow, { key: track.id, isSelectedForPlayer: selected },
                                React.createElement(TableCell, null,
                                    React.createElement(AudioControlButton, { isLoading: loading, onPause: pause, onPlay: onPlay, isPlaying: playing })),
                                React.createElement(TableCell, null, track.title),
                                React.createElement(TableCell, null, track.artist),
                                React.createElement(TableCell, null, track.genres.map(function (genre) { return genre.title; }).join(", ")),
                                React.createElement(TableCell, null, track.duration.formatted),
                                React.createElement(TableCell, null,
                                    React.createElement(IconButton, { size: "small", onClick: function () { return onTrackAdd(track); } },
                                        React.createElement(Add, null))),
                                React.createElement(TableCell, null, isAdded ? (React.createElement(Box, null,
                                    React.createElement(Badge, { badgeContent: addCounter, color: "secondary", invisible: addCounter < 2 },
                                        React.createElement(IconButton, { size: "small", onClick: function () { return onTrackRemove(track.id); } },
                                            React.createElement(Delete, null))))) : (React.createElement(Box, { height: 30, width: 30 })))));
                        }),
                    isLoading &&
                        Array.from({ length: rowsPerPage }).map(function (_, index) { return (React.createElement(TableRow, { key: index }, Array.from({ length: 6 }).map(function (__, number) { return (React.createElement(TableCell, { key: number },
                            React.createElement(Skeleton, null))); }))); })))),
        data && (React.createElement(TablePagination, { component: Paper, count: data.total, page: page, onPageChange: onChangePage, rowsPerPage: rowsPerPage, onRowsPerPageChange: onChangeRowsPerPage, labelRowsPerPage: "Выбрано треков" }))));
};
